import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, option_type, class_type, union_type, string_type, int32_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { News_News_$reflection, News_NewsListItem_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { Paginated$1_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { Remote$1_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";

export class Page extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AllNews", "NewsItem"];
    }
}

export function Page_$reflection() {
    return union_type("News.Types.Page", [], Page, () => [[["page", int32_type]], [["id", string_type]]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadNewsPage", "LoadNews", "NewsPageLoaded", "NewsLoaded", "MarkNewsRead", "MarkNewsReadDone"];
    }
}

export function Msg_$reflection() {
    return union_type("News.Types.Msg", [], Msg, () => [[["page", int32_type]], [["id", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Paginated$1_$reflection(News_NewsListItem_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Paginated$1_$reflection(News_NewsListItem_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [News_News_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", News_News_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [["id", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]]]);
}

export class Model extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AllNewsModel", "NewsItemModel"];
    }
}

export function Model_$reflection() {
    return union_type("News.Types.Model", [], Model, () => [[["Item", AllNewsModel_$reflection()]], [["Item", NewsItemModel_$reflection()]]]);
}

export class AllNewsModel extends Record {
    constructor(PageNumber, NewsList) {
        super();
        this.PageNumber = PageNumber;
        this.NewsList = NewsList;
    }
}

export function AllNewsModel_$reflection() {
    return record_type("News.Types.AllNewsModel", [], AllNewsModel, () => [["PageNumber", option_type(int32_type)], ["NewsList", Remote$1_$reflection(Paginated$1_$reflection(News_NewsListItem_$reflection()))]]);
}

export class NewsItemModel extends Record {
    constructor(Id, NewsItem, BackToPage) {
        super();
        this.Id = Id;
        this.NewsItem = NewsItem;
        this.BackToPage = (BackToPage | 0);
    }
}

export function NewsItemModel_$reflection() {
    return record_type("News.Types.NewsItemModel", [], NewsItemModel, () => [["Id", string_type], ["NewsItem", Remote$1_$reflection(News_News_$reflection())], ["BackToPage", int32_type]]);
}

export function Model__get_Headline(model) {
    if (model.tag === 1) {
        const matchValue = model.fields[0].NewsItem;
        if (matchValue.tag === 3) {
            return matchValue.fields[0].Titel;
        }
        else {
            return "News";
        }
    }
    else {
        return "News";
    }
}

//# sourceMappingURL=Types.fs.js.map
